import { motion } from "motion/react";
import classNames from "classnames/bind";
import { ReactNode, useEffect, useRef, useState } from "react";
import styles from "./Main.module.scss";
import { usePageHighlight } from "@/providers/PageHighlightContext";
import { removeFilterStyles } from "@/core/utils";

const cx = classNames.bind(styles);

interface MainProps {
  children: ReactNode;
  className?: string;
  [key: string]: any;
}

export default function Main({ children, className, ...props }: MainProps) {
  const motionEl = useRef<HTMLElement>(null);
  const [style, setStyle] = useState<React.CSSProperties>({});
  const { highlightColor } = usePageHighlight();

  useEffect(() => {
    document.body.style.setProperty('--highlight-color', highlightColor);
    setStyle({ "--highlight-color": highlightColor } as React.CSSProperties);
  }, [highlightColor]);

  useEffect(() => {
    removeFilterStyles(motionEl.current);
  }, [motionEl]);
  return (
    <motion.main
      tabIndex={-1}
      onAnimationComplete={() => removeFilterStyles(motionEl.current)}
      transition={{ duration: 0.5, ease: "easeInOut" }}
      ref={motionEl}
      className={cx(["main", className])}
      style={style}
      id="main"
    >
      {children}
    </motion.main>
  );
}
